export function ScribbleUnderline({ color = "var(--accent)" }) {
  return (
    <svg viewBox="0 0 200 20" preserveAspectRatio="none" aria-hidden="true">
      <path
        d="M3 12 C 40 4, 70 18, 100 9 S 160 4, 197 13"
        stroke={color}
        strokeWidth="3"
        fill="none"
        strokeLinecap="round"
      />
    </svg>
  );
}
